import { AxiosResponse } from 'axios';
import KrpTechopsAdminResource from '@/api/resource/KrpTechopsAdminResource';
import { SavedDailyLoadFilter } from '@/api/dashboard/SavedDailyLoadFilter';

export class SavedDailyLoadFilterResource extends KrpTechopsAdminResource {
  items: SavedDailyLoadFilter[] = [];

  public async saveFilter(filter : SavedDailyLoadFilter): Promise<SavedDailyLoadFilter> {
    const url: string = '/api/krp/admin/saved-daily-load-filter';
    const response: AxiosResponse = await this.apiClient.post(url, filter);
    const result: SavedDailyLoadFilter = response.data.data;
    return result;
  }

  public async deleteFilter(filter : SavedDailyLoadFilter): Promise<void> {
    const url: string = `/api/krp/admin/saved-daily-load-filter/${filter.id}`;
    const response: AxiosResponse = await this.apiClient.delete(url);
    const result: void = response.data;
    return result;
  }

  public async updateFilter(filter : SavedDailyLoadFilter): Promise<SavedDailyLoadFilter> {
    const url: string = `/api/krp/admin/saved-daily-load-filter/${filter.id}`;
    const response: AxiosResponse = await this.apiClient.put(url, filter);
    const result: SavedDailyLoadFilter = response.data.data;
    return result;
  }

  public async getAll(): Promise<SavedDailyLoadFilter[]> {
    const url: string = '/api/krp/admin/saved-daily-load-filter';
    const response: AxiosResponse = await this.apiClient.get(url);
    this.items = response.data.data;
    return this.items;
  }
}

export default SavedDailyLoadFilterResource;
